"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _domUtils = require("../../utils/dom-utils");
var _styles = require("./styles");
var _excluded = ["children", "fadeColor", "isScrollable"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //helpers
//styled-components
var FadingOverflowComponent = exports["default"] = /*#__PURE__*/function (_Component) {
  function FadingOverflowComponent() {
    var _this;
    _classCallCheck(this, FadingOverflowComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FadingOverflowComponent, [].concat(args));
    _defineProperty(_this, "contentElement", null);
    _defineProperty(_this, "overlayElement", null);
    _defineProperty(_this, "handleScroll", function () {
      _this.update(true);
    });
    _defineProperty(_this, "update", function (shouldAnimate) {
      var isDisabled = _this.props.isDisabled;
      var _this$contentElement = _this.contentElement,
        clientHeight = _this$contentElement.clientHeight,
        scrollHeight = _this$contentElement.scrollHeight,
        scrollTop = _this$contentElement.scrollTop;
      var hasReachedBottom = Math.abs(scrollTop - (scrollHeight - clientHeight)) < 2;
      var hasReachedTop = scrollTop === 0;
      (0, _domUtils.toggleClass)(_this.overlayElement, 'has-reached-bottom', isDisabled || hasReachedBottom);
      (0, _domUtils.toggleClass)(_this.overlayElement, 'has-reached-top', isDisabled || hasReachedTop);
      (0, _domUtils.toggleClass)(_this.overlayElement, 'should-animate', shouldAnimate);
    });
    return _this;
  }
  _inherits(FadingOverflowComponent, _Component);
  return _createClass(FadingOverflowComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update(false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        fadeColor = _this$props.fadeColor,
        isScrollable = _this$props.isScrollable,
        forwardedProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_styles.OffsetParent, forwardedProps, /*#__PURE__*/_react["default"].createElement(_styles.InnerWrapper, {
        ref: function ref(_ref) {
          _this2.contentElement = _ref;
        },
        isScrollable: isScrollable,
        onScroll: this.handleScroll
      }, children), /*#__PURE__*/_react["default"].createElement(_styles.FadingOverlay, {
        color: fadeColor,
        ref: function ref(_ref2) {
          _this2.overlayElement = _ref2;
        },
        isScrollable: isScrollable
      }));
    }
  }]);
}(_react.Component);
_defineProperty(FadingOverflowComponent, "defaultProps", {
  fadeColor: '#fff',
  isDisabled: false,
  isScrollable: true
});
_defineProperty(FadingOverflowComponent, "propTypes", {
  fadeColor: _propTypes["default"].string,
  isDisabled: _propTypes["default"].bool,
  isScrollable: _propTypes["default"].bool
});
//# sourceMappingURL=index.js.map